import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ContentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import ComponentImage from "GeneralComponents/ComponentImage";
import { MediaItem } from "Interfaces/general.interface";
import { ContentShowListProps as Props } from "MiniSiteComponents/ContentShow/ContentShow.interface";
import "./DynamicList.min.css";

const DynamicList: React.FC<Props> = (props) => {
  const {
    componentId,
    iconView,
    itemsToShowOnLoad,
    isShowMore,
    dir,
    items,
    noImagesClass,
    linkTarget,
    itemsNumberInRow,
  } = props;

  const displayCountClass = getCountDisplayClassName(items.length);

  // Drive desktop items-per-row from the `itemsNumberInRow` prop via a CSS custom property.
  // Clamp to a sensible range; values outside it (e.g. the "999" sentinel meaning "show all")
  // fall back to the default layout defined in the stylesheet.
  const itemsPerRow = Number(itemsNumberInRow);
  const ulStyle: React.CSSProperties | undefined =
    Number.isFinite(itemsPerRow) && itemsPerRow > 0 && itemsPerRow <= 6
      ? ({ ["--mst-items-per-row" as never]: itemsPerRow } as React.CSSProperties)
      : undefined;

  function configureLinkClass(item: ContentShowItem) {
    if (item.url || (item.link && item.link.url)) {
      const linkUrlInit = ["/", "http", "tel:"];
      const isValidLinkUrl = item.link.url && linkUrlInit.some((url) => item.link.url.startsWith(url));
      const isValidPageUrl = item.url && item.url.startsWith("/");
      const isValidLink = isValidLinkUrl || isValidPageUrl;

      if (isValidLink) return "hasLink";
    }
    return "";
  }

  function getCountDisplayClassName(itemsLength: number) {
    if (itemsLength === 6) return "mst-Dynamic-List-SixItems";
    if (itemsLength === 5) return "mst-Dynamic-List-FiveItems";
    return "";
  }

  return (
    <ul
      id={"mst-content-list-" + componentId}
      style={ulStyle}
      className={`list-posts mst-Dynamic-List px-2 d-flex flex-wrap ${displayCountClass} ${noImagesClass} ${"justify-content-" + props.alignment}
            `}
    >
      {items.map((item, idx) => {
        const { richDescription, title, icon, image, mobileImage, url, link, content } = item;
        const isItemDisplay = idx < itemsToShowOnLoad || isShowMore;
        const linkClass = configureLinkClass(item);

        return (
          <li
            key={item.index}
            className={`list-group-item mst-DynamicListItem  mx-2 mx-md-3 
                        ${isItemDisplay ? "" : "d-none"}`}
          >
            <div className={"mst-dynamicListContent " + linkClass}>
              {image && !iconView ? (
                <ComponentImage
                  image={image}
                  imageClass=""
                  mobileImage={mobileImage}
                  mobileImageClass=""
                  wrapperDivClass="mst-dynamicListView-img"
                  cropAlias="rectangleImage"
                />
              ) : (
                <div className="mst-dynamicListView-icon justify-content-center pt-3 pt-md-5">
                  <div className="round-border p-1">
                    <div className="round-bg">
                      <i className={icon + " minisite-font-36 d-flex justify-content-center"}></i>
                    </div>
                  </div>
                </div>
              )}

              <div className="mst-dynamicListView-itemTitle p-2 px-lg-3 pb-lg-4 pt-lg-4">
                <div className="">
                  <div className="mx-auto">
                    <span>{title}</span>
                  </div>
                </div>
              </div>

              <CustomLinkButton
                title={title || ""}
                pageUrl={url}
                link={link}
                isBtn={false}
                linkClass="mst-overlay-link"
                dir={dir}
                linkTarget={linkTarget}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default DynamicList;
